import { MRT_PaginationState } from "material-react-table";
import React from "react";
import { useQuery } from "react-query";
import { useAuth } from "src/shared/context/useAuth";
import { getPastAadeCases } from "./gateway";

export default function useGetPastAadeCases({
  filters,
  enabled,
  setEnableSearch,
  tab,
  paginationState,
}: {
  enabled: Boolean;
  filters: Object;
  setEnableSearch: React.Dispatch<React.SetStateAction<Boolean>>;
  tab: Number;
  paginationState: MRT_PaginationState;
}) {
  const { isOrgAdmin } = useAuth();

  const fetchForEntireChamber = tab === 1 && isOrgAdmin;

  return useQuery({
    queryFn: () =>
      getPastAadeCases(filters, paginationState, fetchForEntireChamber),
    queryKey: ["past-aadeCases", filters, tab, paginationState],
    onSettled: () => {
      setEnableSearch(false);
    },
    enabled: !!enabled,
  });
}
